//@flow
import {
  PHONE_REGISTRATION,
  ONE_TIME_PASSWORD,
  PHONE_HAS_REGISTRATION,
  BECOME_SELLER,
  ACTION_SELLER_SELL,
  AWB_SENT_KA,
  UPDATE_LISTING_EXPIRY,
  SELLER_INPUT_AWB,
  SENT_SMS,
  SENT_CALL
} from './saleConstants';
import {
  FontFamilyBold,
  FontFamilyRegular
} from "./styledComponents";
export const LOCAL_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://localhost';
export const PROD_ES_URL = "https://ecngcyc9sa.execute-api.ap-southeast-1.amazonaws.com/prod/search";
export const STAGING_ES_URL = "https://ecngcyc9sa.execute-api.ap-southeast-1.amazonaws.com/prod/sandbox-search";
export const DEV_ES_URL = "https://ywawsbj8j7.execute-api.ap-southeast-1.amazonaws.com/dev/search";
// export const PRODUCT_SEARCH_ES_URI = "https://ecngcyc9sa.execute-api.ap-southeast-1.amazonaws.com/prod/sandbox-search";
// export const PRODUCT_SEARCH_ES_URI = "https://ecngcyc9sa.execute-api.ap-southeast-1.amazonaws.com/prod/search";
// export const PRODUCT_SEARCH_ES_URI = "https://ywawsbj8j7.execute-api.ap-southeast-1.amazonaws.com/dev/search";
export const PRODUCT_SEARCH_ES_URI = ~document.location.hostname.indexOf("staging.kickavenue.com") ? DEV_ES_URL : process.env.REACT_APP_PRODUCT_SEARCH_ES_URI;

// export const BASE_URL = 'http://localhost:3000';
//export const API_BASE_URL:string ='http://develop2.kickavenue.com';
// export const API_BASE_URL = 'https://develop3.kickavenue.com'; //Lumen API on LightSail
// export const API_BASE_URL = 'https://api.kickavenue.com';
// export const API_BASE_URL = 'https://lumenstaging.kickavenue.com';
export const STAGING_API_BASE_URL = 'https://lumenstaging.kickavenue.com';
export const PROD_API_BASE_URL = 'https://api.kickavenue.com';
export const DEV_API_BASE_URL = 'https://develop3.kickavenue.com';
export const API_BASE_URL = ~document.location.hostname.indexOf("staging.kickavenue.com") ? STAGING_API_BASE_URL : LOCAL_API_BASE_URL;

// BLOG API
export const BLOG_API_BASE_URL = API_BASE_URL;

// export const REDIRECT_FB_MOBILE='http://localhost:3000/'
// export const REDIRECT_FB_MOBILE='http://develop-web.ap-southeast-1.elasticbeanstalk.com/'
// export const REDIRECT_FB_MOBILE='https://web.kickavenue.com/' //activated if push on branch to master

//PERSONALIZE
export const ACCESS_KEY_ID = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
export const SECRET_ACCESS_KEY = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
export const TRACKING_ID = process.env.REACT_APP_PERSONALIZE_TRACKING_ID;

export const AUTH_TOKEN_KEY = (new Buffer('_token').toString('base64'));
export const AUTH_USER_KEY = (new Buffer('_user').toString('base64'));
export const COURIER_PRICE_KEY = (new Buffer('_courierPrice').toString('base64'));
export const SORTING_SEARCH_RESULT_API = "SORTING_SEARCH_RESULT_API"
export const AUTH_SUBSCRIBE = 'AUTH_SUBSCRIBE';
export const AUTH_SUBSCRIBE_ERROR = 'AUTH_SUBSCRIBE_ERROR';
export const SUBMIT_AUTH_SUBSCRIBE = 'SUBMIT_AUTH_SUBSCRIBE';
export const GET_TIMER = "GET_TIMER"

export const GET_COLLECTION_UNDER_RETAIL = 'GET_COLLECTION_UNDER_RETAIL';
export const GET_COLLECTION_MERCHANDISE = 'GET_COLLECTION_MERCHANDISE';

export const GET_COLLECTION_VARIANTS = 'GET_COLLECTION_VARIANTS';
export const AUTH_SIGN_IN_POST = 'ka-web/auth/signin/POST';
export const AUTH_SIGN_UP_POST = 'ka-web/auth/signup/POST';
export const AUTH_PROFILE_FETCH = 'ka-web/auth/me/FETCH';
export const AUTH_CURRENCY_RATE_FETCH = 'ka-web/currency_ratio/FETCH';
export const AUTH_REFRESH_TOKEN_FETCH = 'ka-web/auth/me/refresh/FETCH';
export const AUTH_SIGN_OUT = 'ka-web/auth/me/SIGNOUT';

export const AUTH_SOCIAL_SIGN_IN = 'ka-web/auth/social';

export const AUTH_PROFILE_UPDATE = 'AUTH_PROFILE_UPDATE';
export const AUTH_COUNTRY_UPDATE = 'AUTH_COUNTRY_UPDATE';

export const EMAIL_VERIFICATION_LINK_SENT = 'ka-web/auth/me/verification/email/link/PUT';
export const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
export const EMAIL_VERIFICATION_SUBMIT = 'EMAIL_VERIFICATION_SUBMIT';
export const EMAIL_VERIFICATION_ERROR = 'EMAIL_VERIFICATION_ERROR';

export const GET_PRODUCTS_RELEASED = 'GET_PRODUCTS_RELEASED';

export const PRODUCTS_FETCH = 'ka-web/products/FETCH';
export const PRODUCTS_FETCH_POPULAR = 'ka-web/products/FETCH_POPULAR';
export const PRODUCTS_FETCH_RELATED = 'ka-web/products/FETCH_RELATED';
export const PRODUCT_DETAIL_FETCH = 'ka-web/products/detail/FETCH';

export const BRAND_PRODUCT = "BRAND_PRODUCT"

// constants search the product
export const PRODUCT_SEARCH_TO_KA_API = 'PRODUCT_SEARCH_TO_KA_API';
export const PRODUCT_SEARCH_PENDING_TOGGLE = 'PRODUCT_SEARCH_PENDING_TOGGLE';
export const SORTING_SEARCH_RESULT = 'SORTING_SEARCH_RESULT';
export const GET_ALL_BRANDS = 'GET_ALL_BRANDS';
export const GET_ALL_SIZES = 'GET_ALL_SIZES';
export const FILTERING_SEARCH_RESULT = 'FILTERING_SEARCH_RESULT';
export const CLEAR_BEFORE_FILTERING = 'CLEAR_BEFORE_FILTERING';
export const FILTERING_HOMESCREEN = 'FILTERING_HOMESCREEN';
export const BROWSE_ALL_PRODUCT = 'BROWSE_ALL_PRODUCT';
export const BROWSE_ALL_POPULAR_SEARCH = 'BROWSE_ALL_POPULAR_SEARCH';
export const GET_SIZE_BASE_PRODUCT_ID = 'GET_SIZE_BASE_PRODUCT_ID';
export const UPDATE_ACTIVE_PRODUCT = 'UPDATE_ACTIVE_PRODUCTS';
export const MODAL_SEARCH_TOGGLE = 'MODAL_SEARCH_TOGGLE';
export const SEARCH_RESULT_LOAD_MORE = 'SEARCH_RESULT_LOAD_MORE';
export const GET_ADDITIONAL_PRODUCT = 'GET_ADDITIONAL_PRODUCT';
export const EDITORS_CHOICE_PRODUCT = 'EDITORS_CHOICE_PRODUCT';
export const GET_FLASH_SALE_SETTING = "GET_FLASH_SALE_SETTING";
export const GET_TICKET_LIST_SETTING = "GET_TICKET_LIST_SETTING";
export const UPCOMING_PRODUCT = 'UPCOMING_PRODUCT';
export const GET_HANDBAG_CONDITIONS = 'GET_HANDBAG_CONDITIONS';
export const ALL_HANDBAG_CONDITION_PENDING = 'ALL_HANDBAG_CONDITION_PENDING';
export const ALL_HANDBAG_CONDITION_FULFILLED = 'ALL_HANDBAG_CONDITION_FULFILLED';
export const ALL_HANDBAG_CONDITION_REJECTED = 'ALL_HANDBAG_CONDITION_REJECTED';
export const USER_RECENT_SEARCH = 'USER_RECENT_SEARCH';
export const GET_TRENDING_PRODUCT = "GET_TRENDING_PRODUCT";
export const GET_TOP_SELLING_PRODUCT = "GET_TOP_SELLING_PRODUCT";
export const GET_CONCIERGE = "GET_CONCIERGE";
export const PUT_CONCIERGE = "PUT_CONCIERGE"
export const GET_SPINNING_WHEEL = "GET_SPINNING_WHEEL"
export const POST_SPINNING_WHEEL = "POST_SPINNING_WHEEL"
export const GET_SPINNING_WHEEL_PRIZE = "GET_SPINNING_WHEEL_PRIZE"
export const GET_COLLECTION_BY_SLUG = "GET_COLLECTION_BY_SLUG";
export const GET_ALL_COLLECTION_BY_SLUG = "GET_ALL_COLLECTION_BY_SLUG";
export const GET_COLLECTION_PRODUCT_LIST = "GET_COLLECTION_PRODUCT_LIST"
export const SECTION_DETAILS = "SECTION_DETAILS"
export const REQUEST_TO_ELASTIC_SEARCH = "REQUEST_TO_ELASTIC_SEARCH"

export const FILTERING_FROM_API = 'FILTERING_FROM_API';
export const GET_COLLECTION_LIST = 'GET_COLLECTION_LIST';
export const GET_FLASH_SALE_DETAIL = "GET_FLASH_SALE_DETAIL"
export const GET_RAFFLE_PRODUCTS = 'GET_RAFFLE_PRODUCTS';
export const POST_RAFFLE_PRODUCTS = 'POST_RAFFLE_PRODUCTS';

// DISBURSEMENT
export const REQUEST_DISBURSEMENT = 'REQUEST_DISBURSEMENT';
export const DISBURSEMENT_HISTORY = 'DISBURSEMENT_HISTORY';

//common ground
export const GET_COMMONGROUND = 'GET_COMMONGROUND';
export const POST_COMMONGROUND = 'POST_COMMONGROUND';
export const CART_ADD = 'ka-web/products/carts/ADD';

export const POSTALCODE_COUNTRIES_FETCH = 'ka-web/postalcode/countries/FETCH';
export const POSTALCODE_PROVINCES_FETCH = 'ka-web/postalcode/provinces/FETCH';
export const POSTALCODE_CITIES_FETCH = 'ka-web/postalcode/cities/FETCH';
export const COURIERS_COST_POST = 'ka-web/couriers/cost/POST';

export const RESET_PASSWORD = 'ka-web/reset/password/POST';
export const REQUEST_RESET_PASSWORD = 'ka-web/reset/password/request/POST';
export const CLEAR_RESET_PASSWORD = 'CLEAR_RESET_PASSWORD';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

export const PROMISE_PENDING = '_PENDING';
export const PROMISE_REJECTED = '_REJECTED';
export const PROMISE_FULFILLED = '_FULFILLED';

export const PAYMENTS_POST = 'ka-web/payments/POST';
export const PAYMENTS_DETAIL_GET = 'ka-web/payments/detail/GET';
export const PAYMENTS_XENDIT_POST = 'ka-web/payments/xendit/POST';
export const PAYMENTS_MIDTRANS_POST = 'ka-web/payments/midtrans/POST';
export const PAYMENTS_MIDTRANS_TOKENS_POST = 'ka-web/payments/midtrans/tokens/POST';
export const PAYMENTS_MIDTRANS_DETAIL_GET = 'ka-web/payments/midtrans/detail/GET';
export const PAYMENTS_KREDIVO_POST = 'ka-web/payments/kredivo/POST';
export const PAYMENTS_KREDIVO_INSTALLMENTS_TYPE_POST = 'ka-web/payments/kredivo/installments/POST';
export const PAYMENTS_AKULAKU_POST = 'ka-web/payments/akulaku/POST';
export const PAYMENTS_ATOME_POST = 'ka-web/payments/atome/POST';
export const PAYMENTS_AKULAKU_INSTALLMENTS_TYPE_POST = 'ka-web/payments/akulaku/installments/POST';
export const PAYMENTS_BANK_ACCOUNTS_GET = 'ka-web/payments/bank_accounts/GET';
export const PAYMENTS_BANK_TRANSFER_POST = 'ka-web/payments/bank_transfer/confirm/POST';
export const PAYMENTS_APPLY_VOUCHER_POST = 'ka-web/payments/vouchers/POST';
export const GET_VOUCHER_CODE = "GET_VOUCHER_CODE";
export const PRODUCT_ADDON_FETCH = 'PRODUCT_ADDON_FETCH';

export const HISTORY_PAYMENTS = 'ka-web/history/payments/GET'
export const HISTORY_PAYMENTS_PROCESSED = 'ka-web/history/payments_processed/GET'
export const HISTORY_PAYMENTS_COMPLETED = 'HISTORY_PAYMENTS_COMPLETED';
export const LIST_SELLING = 'ka-web/history/selling/GET'
export const LIST_SELLING_PENDING = 'ka-web/history/process/GET'
export const LIST_SELLING_HISTORY = 'ka-web/history/sells/GET'
// export const HISTORY_SELLS:'ka-web/history/sells/GET' = 'ka-web/history/sells/GET'
export const BUY_COMPLETIONS = 'BUY_COMPLETIONS'

export const SHIPPING_POST = 'SHIPPING_POST';
export const USER_HISTORY_SHIPPING = 'USER_HISTORY_SHIPPING';
export const HISTORY_SHIPPING_UPDATE = 'HISTORY_SHIPPING_UPDATE';
export const SET_DEFAULT_ADDRESS = "SET_DEFAULT_ADDRESS"
export const DELETE_SHIPPING_ADDRESS = "DELETE_SHIPPING_ADDRESS"

export const USER_SIZES_FETCH = 'USER_SIZES_FETCH';
export const USER_SIZE_POST = 'USER_SIZE_POST';
export const USER_SIZE_UPDATE = 'USER_SIZE_UPDATE';

export const USER_BANK_ACCOUNT_FETCH = 'USER_BANK_ACCOUNT_FETCH';
export const USER_BANK_ACCOUNT_POST = 'USER_BANK_ACCOUNT_POST';
export const USER_BANK_ACCOUNT_UPDATE = 'USER_BANK_ACCOUNT_UPDATE';
export const GET_BANK_LIST = "GET_BANK_LIST";

export const SIZES_FETCH = 'SIZES_FETCH';

export const SAVING_SEARCH_QUERY = 'SAVING_SEARCH_QUERY';

export const ASCENDING = 'ASCENDING'
export const DESCENDING = 'DESCENDING'

export const INC_DATA_PEMBELIAN = 'DATA-PEMBELIAN'
export const INC_DATA_PEMBELIAN_PROCESSED = 'DATA-PEMBELIAN-PROCESSED'
export const INC_DATA_PEMBELIAN_COMPLETED = 'DATA-PEMBELIAN-COMPLETED'

//FILTER AND SORT
export const SORT_FILTER_SELLING_SELLER = 'SORT_FILTER_SELLING_SELLER'
export const SORT_FILTER_PROCESS_SELLER = 'SORT_FILTER_PROCESS_SELLER'
export const SORT_FILTER_HISTORY_SELLER = 'SORT_FILTER_HISTORY_SELLER'

//TOP UP
export const TOP_UP_POST = 'TOP_UP_POST'

//WALLET HISTORY
export const TOP_UP_HISTORY = 'TOP_UP_HISTORY'
export const CASH_OUT_HISTORY = 'CASH_OUT_HISTORY'
export const GET_SELLER_CASHOUT_FEE = "GET_SELLER_CASHOUT_FEE"
export const GET_DISBURSEMENT_SETTING = "GET_DISBURSEMENT_SETTING"

// SELL REQUEST
export const MAKE_SALE_REQUEST = 'MAKE_SALE_REQUEST';
export const CLEAR_SELL_REQUEST = 'CLEAR_SELL_REQUEST';
export const SELLER_UPLOAD_PHOTO = 'SELLER_UPLOAD_PHOTO';
export const SAVING_SELLER_IMAGE = 'SAVING_SELLER_IMAGE';
export const SUSPEND_SELL_REQUEST = 'SUSPEND_SELL_REQUEST';
export const HOLIDAY_MODE_REQUEST = 'HOLIDAY_MODE_REQUEST';
export const FETCH_PRICE_COMPETITOR = "FETCH_PRICE_COMPETITOR";
export const FETCH_DISTRICT = "FETCH_DISTRICT";

//OFFER
export const HIGHEST_OFFER_FETCH = 'HIGHEST_OFFER_FETCH';
export const USER_OFFER_POST = 'USER_OFFER_POST';
export const VALIDATE_OFFER = 'VALIDATE_OFFER';
export const USER_OFFER_HISTORY_LIST = 'USER_OFFER_HISTORY_LIST';
export const USER_OFFER_PENDING_LIST = 'USER_OFFER_PENDING_LIST';
export const USER_OFFER_ACCEPTED_LIST = 'USER_OFFER_ACCEPTED_LIST';
export const USER_OFFER_DETAILS_FETCH = 'USER_OFFER_DETAILS_FETCH';
export const PENDING_OFFER_LIST_NEW = 'PENDING_OFFER_LIST_NEW';
export const PENDING_OFFER_LIST = 'PENDING_OFFER_LIST';
export const UPDATE_OFFER_USER = 'UPDATE_OFFER_USER';
export const DELETE_OFFER_USER = 'DELETE_OFFER_USER';
export const ACCEPT_OFFER_REQUEST = 'ACCEPT_OFFER_REQUEST';
export const FETCH_MAX_AMOUNT = 'FETCH_MAX_AMOUNT';

// Search
export const SEARCH_STATE = 'SEARCH_STATE'
export const CLICK_MENU_NAVBAR = "CLICK_MENU_NAVBAR";
export const FETCH_COLLECTION_PRODUCT_LIST = "FETCH_COLLECTION_PRODUCT_LIST";

export const RESET_TOKEN_TOBE_SELLER = 'RESET_TOKEN_TOBE_SELLER'

export const SLIDER_HOME = 'SLIDER_HOME';
export const SLIDER_ITEM_CLICK = 'SLIDER_ITEM_CLICK';

export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const GET_MOST_SEARCH_RESULTS = 'GET_MOST_SEARCH_RESULTS';
export const FETCHING_MOST_SEARCH_RESULTS = 'FETCHING_MOST_SEARCH_RESULTS';
export const MOST_SEARCH_RESULTS_ERROR = 'MOST_SEARCH_RESULTS_ERROR';
export const SEARCH_OPEN = 'SEARCH_OPEN';

//MENU
export const GET_LIST_MENU = 'GET_LIST_MENU';

//SKU REQUEST
export const CREATE_SKU_REQUEST = 'CREATE_SKU_REQUEST';
export const UPDATE_SKU_REQUEST = 'UPDATE_SKU_REQUEST';

//KICK POINT
export const GET_USER_POINT = 'GET_USER_POINT';
export const GET_POINT_TIER = 'GET_POINT_TIER';
export const GET_POINT_HISTORY = 'GET_POINT_HISTORY';
export const GET_USER_VOUCHER = 'GET_USER_VOUCHER';
export const GET_USER_RAFFLE = 'GET_USER_RAFFLE';
export const GET_VOUCHER_HISTORY = 'GET_VOUCHER_HISTORY';
export const GET_RAFFLE_HISTORY = 'GET_RAFFLE_HISTORY';

// TRANSACTION TIMELINE
export const GET_TRANSACTION_TIMELINE = "GET_TRANSACTION_TIMELINE";

// BID VALIDATION
export const FETCH_BID_VALIDATION = 'FETCH_BID_VALIDATION';
export const BID_VALIDATION = 'BID_VALIDATION';

export const SET_LOGIN_REFERRAL = 'SET_LOGIN_REFERRAL'
export const IS_FROM_WEB_APPS = 'IS_FROM_WEB_APPS'

// CONCIERGE
export const POST_CONCIERGE = 'POST_CONCIERGE'

// SALE HISTORY
export const FECTH_SHOES_SALE_HISTORY_DATA = "FECTH_SHOES_SALE_HISTORY_DATA"

// GET COURIER LIST
export const FETCH_ALL_COURIER = 'FETCH_ALL_COURIER'

// MODAL TRACKING NUMBER
export const FETCH_SHIPPING_TRACKING = "FETCH_SHIPPING_TRACKING"
export const POST_PICKUP_IDEXPRESS = "POST_PICKUP_IDEXPRESS"
export const PASSING_SALE_ID_EXPRESS = "PASSING_SALE_ID_EXPRESS"
export const ALLOWED_PICKUP_IDEXPRESS = "ALLOWED_PICKUP_IDEXPRESS"
export const POST_CANCEL_PICKUP_IDEXPRESS = "POST_CANCEL_PICKUP_IDEXPRESS"
export const GET_SHIPPING_FEE_PICKUP_IDEXPRESS = "GET_SHIPPING_FEE_PICKUP_IDEXPRESS"

export const SET_FILTER_SEARCH = 'SET_FILTER_SEARCH';
export const SET_SORT_BY_SEARCH = 'SET_SORT_BY_SEARCH';
export const RESET_USER_DASHBOARD_FILTER = 'RESET_USER_DASHBOARD_FILTER';
export const SET_USER_DASHBOARD_KEYWORD = 'SET_USER_DASHBOARD_KEYWORD';
export const SET_USER_DASHBOARD_SORT = 'SET_USER_DASHBOARD_SORT';
export const SET_USER_DASHBOARD_CATEGORY = 'SET_USER_DASHBOARD_CATEGORY';
export const SET_USER_DASHBOARD_STATUS = 'SET_USER_DASHBOARD_STATUS';
export const SET_USER_DASHBOARD_PAGE = 'SET_USER_DASHBOARD_PAGE';
export const RESET_USER_DASHBOARD_KEYWORD = 'RESET_USER_DASHBOARD_KEYWORD';
export const GET_SELLING_COMMISSION_FEE_SETTING = 'GET_SELLING_COMMISSION_FEE_SETTING';
// FAQ
export const FETCH_FAQS = "FETCH_FAQS"

// COLLECTION
export const COLLECTION_HOMEPAGE = "COLLECTION_HOMEPAGE"
export const GET_PRE_VERIFIED_COLLECTION_LIST = "GET_PRE_VERIFIED_COLLECTION_LIST"

// SHOPPING CART
export const GET_SHOPPING_CART_LIST = "GET_SHOPPING_CART_LIST"
export const DELETE_SHOPPING_CART = "DELETE_SHOPPING_CART"
export const POST_SHOPPING_CART_PRODUCT = "POST_SHOPPING_CART_PRODUCT"

// RECOMMENDED PRODUCTS
export const RECOMMENDED_PRODUCT = "RECOMMENDED_PRODUCT"
export const RECOMMENDED_PRODUCT_FULFILLED = 'RECOMMENDED_PRODUCT_FULFILLED';
export const RECOMMENDED_PRODUCT_PENDING = 'RECOMMENDED_PRODUCT_PENDING';
export const RECOMMENDED_PRODUCT_ERROR = 'RECOMMENDED_PRODUCT_ERROR';

// SURVEY
export const GET_SURVEY = "GET_SURVEY"
export const GET_USER_PREFERENCE = "GET_USER_PREFERENCE"
export const POST_SURVEY = "POST_SURVEY"
// UPLOAD IMAGE TO S3
export const UPLOAD_IMAGE_S3 = 'UPLOAD_IMAGE_S3';

// SHIPPER
export const SHIPPER_KEY = process.env.REACT_APP_SHIPPER_KEY;
export const SHIPPER_BASE_URL = "https://merchant-api-sandbox.shipper.id";
export const SHIPPER_LOCATION = "SHIPPER_LOCATION";
export const SHIPPER_DOWNLOAD_STICKER_URL = process.env.REACT_APP_SHIPPER_DOWNLOAD_STICKER_URL;
export const SHIPPER_DOWNLOAD_RECEIPT_URL = process.env.REACT_APP_SHIPPER_DOWNLOAD_RECEIPT_URL;

const COMPANY_NAME = "PT KARUNIA INTERNASIONAL CITRA KENCANA";
const REK_NUMBER = '198 998 8059';

const CURRENCY_CODE = {
  "IDN": "IDR",
  // "MYS": "MYR",
  // "SGP": "SGD",
  "ETC": "USD"
}

const AmplifyConfig = {
  // To get the AWS Credentials, you need to configure 
  // the Auth module with your Cognito Federated Identity Pool
  Auth: {
    identityPoolId: 'ap-southeast-1:2f266fbc-e8f5-48d1-b084-1f239f15a3b7',
    region: 'ap-southeast-1'
  },
  Analytics: {
    // OPTIONAL - disable Analytics if true
    disabled: ~document.location.hostname.indexOf("kickavenue.com") ? false : true,
    // OPTIONAL - Allow recording session events. Default is true.
    autoSessionRecord: true,
    AWSPinpoint: {
      // OPTIONAL -  Amazon Pinpoint App Client ID
      appId: '38d2d2db64524818915de1bc5edf86b4',
      // OPTIONAL -  Amazon service region
      region: 'us-west-2'
    }
  }
}

const PersonalizeConfig = {
  //new configuration for personalize
  AmazonPersonalize: {
    // REQUIRED - The trackingId to track the events 
    trackingId: 'd9348601-ab2b-4297-8957-e8fa3f98ab10',

    // OPTIONAL -  Amazon Personalize service region
    region: 'ap-southeast-1',

    // OPTIONAL - The number of events to be deleted from the buffer when flushed.
    flushSize: 10,

    // OPTIONAL - The interval in milliseconds to perform a buffer check and flush if necessary.
    flushInterval: 5000, // 5s
  }
}

export {
  PHONE_REGISTRATION,
  ONE_TIME_PASSWORD,
  PHONE_HAS_REGISTRATION,
  BECOME_SELLER,
  ACTION_SELLER_SELL,
  SELLER_INPUT_AWB,
  AWB_SENT_KA,
  COMPANY_NAME,
  REK_NUMBER,
  UPDATE_LISTING_EXPIRY,
  CURRENCY_CODE,
  SENT_SMS,
  SENT_CALL,
  AmplifyConfig,
  PersonalizeConfig,
  FontFamilyBold,
  FontFamilyRegular
}
